import React from 'react';
import { Row, Col } from 'antd';
import Slider from "react-slick";
import { getChildrenToRender } from '../utils';
import { Content5DataSource } from '../data';

function Content5(props) {
  const {  isMobile } = props;
  const dataSource = Content5DataSource;
  const { blockWrapper, leftBgImg } = dataSource;
  const childrenToRender = blockWrapper.children.map((item, i) => (
    <div className={blockWrapper.className} key={i.toString()}>
      <div {...item.top}>
        {item.top.children.map(getChildrenToRender)}
      </div>
      <div {...item.middle}>
          {item.middle.children.map((child, j) => (<div {...child}>
            {child.name !== 'array' && getChildrenToRender(child, j)}
            {child.name === 'array' && <Row>{child.children.map((subchild) =>
              <Col {...subchild}>
                {subchild.children.map(getChildrenToRender)}
              </Col>)}</Row>}
          </div>))}
      </div>



          <div {...item.bottom}>
            {item.bottom.children.map((child, j) => (<div {...child}>
              {child.name !== 'array' && getChildrenToRender(child, j)}
              {child.name === 'array' && <Row >{child.children.map((subchild) =>
                <Col {...subchild}>
                {subchild.children.map(getChildrenToRender)}
                </Col>)}
              </Row>}
            </div>))}
          </div>
    </div>
  ));

  const settings = {
    dots: false,
    lazyLoad: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 2,
  };
  return (
    isMobile ? childrenToRender:<Row>
      <Col span={12}>
        <img alt='apexDB demo' {...leftBgImg} ></img>
      </Col>
      <Col span={12} className='content5-right'>
        <div className='content5-right-bg'></div>
        <Slider {...settings}>
          {childrenToRender}
        </Slider>
        </Col>

    </Row>
  );
}

export default Content5;
